export const update = {
  form: {
    name: '部品名',
    totalTimeUsed: '洗浄耐用回数',
    totalLife: 'アラート回数',
    submit: '新規追加',
    timeUnit: '回',
    addMoreMachineComponent: '洗濯機部品追加',
    requireTotalTimeUsed: '洗浄耐用回数を入力してください',
    requireServiceLife: 'アラート回数を入力してください',
    requireName: '機械部品の名前を入力してください',
    update: '保存',
    cancel: 'キャンセル',
    invalidNumbers: '数字のみ入力できます。',
  },
  pageHeader: {
    title: '水洗機部品　情報編集画面',
    back: '戻る',
  },
}
